var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('TheHeader'),_c('AboutUs'),(_vm.$i18n.locale === 'ru')?_c('Resources'):_vm._e(),_c('Advantages'),_c('Clients'),_c('Reviews'),(_vm.$i18n.locale === 'ru')?_c('Interviews'):_vm._e(),_c('FormBox')],1)}
var staticRenderFns = []

export { render, staticRenderFns }